// Clase del objeto TypeIrrigation.
class TypeIrrigation {
    // Constructor del objeto TypeIrrigation.
    constructor(props) {
        this.type = "TypeIrrigation";
        // noinspection DuplicatedCode
        if (props !== null) {
            this.id = props.id;
            this.name = props.name;
            this.acronym = props.acronym;
            this.detail = props.detail;
        } else {
            this.id = "-1";
            this.name = "";
            this.acronym = "";
            this.detail = "";
        }
    }
}

export default TypeIrrigation;